module.exports = __webpack_public_path__ + "img/truck-ongoing.6a858575.svg";